<div class="churn-insight-container">
  <div class="churn-insight-heading">
    <div class="icon-container">
      <rt-icon [name]="iconName()" colorToken="colorIconOnghostDefault" />
    </div>
    @if (tooltip()) {
      <div
        rtTooltip
        [rtTooltipHasNoArrow]="true"
        [rtTooltipMaxWidth]="850"
        [rtTooltipTemplate]="tooltipTemplate"
      >
        <rt-icon name="help-outline" />
      </div>
    }
  </div>
  <div class="churn-insights">
    <div class="core">
      <span class="value">{{ value() }}</span>
      @if (title()) {
        <span class="title">{{ title() }}</span>
      }
    </div>
    <span class="label"> {{ label() }} </span>
  </div>
</div>

<ng-template #tooltipTemplate>
  <div [innerHTML]="tooltip()"></div>
</ng-template>
